import { LegalShell, type LegalLang } from './legalShared'

const APP = 'Provisyer'

export default function TermsOfServicePage({ lang = 'tr' }: { lang?: LegalLang }) {
  return lang === 'en' ? <TermsEN /> : <TermsTR />
}

/* ------------------------------------------------------------------ */
/* TÜRKÇE                                                              */
/* ------------------------------------------------------------------ */
function TermsTR() {
  return (
    <LegalShell lang="tr" page="terms" title="Hizmet Şartları" updated="Son güncelleme: 24 Temmuz 2026">
      <p>
        Bu Hizmet Şartları (&quot;Sözleşme&quot;), {APP} platformunun (&quot;Hizmet&quot;) kullanımına ilişkin koşulları
        düzenler. {APP}, işletmelere bulut üzerinde barındırılan iş uygulamaları (Odoo tabanlı ERP kurulumları
        ve ilgili altyapı) sunan bağımsız bir barındırma (hosting) hizmetidir. {APP}; Odoo S.A. veya herhangi
        bir yazılım sağlayıcısıyla bağlantılı, onlar tarafından desteklenen veya onaylanan bir kuruluş değildir.
        Hesap oluşturarak veya Hizmet&apos;i kullanarak bu Sözleşme&apos;yi kabul etmiş sayılırsınız. Koşulları kabul
        etmiyorsanız Hizmet&apos;i kullanmamalısınız.
      </p>

      <h2>1. Taraflar ve Kapsam</h2>
      <p>
        Bu Sözleşme, Hizmet&apos;i işleten platform operatörü ({APP}, &quot;biz&quot;) ile Hizmet&apos;e kaydolan
        gerçek veya tüzel kişi (&quot;Kullanıcı&quot;, &quot;siz&quot;) arasında elektronik ortamda kurulur. Sözleşme,
        siz Hizmet&apos;i kullandığınız sürece yürürlükte kalır.
      </p>

      <h2>2. Tanımlar</h2>
      <ul>
        <li><strong>&quot;Hizmet&quot;</strong> - web uygulaması, API ve kurulumların oluşturulması, yönetilmesi ve barındırılması için kullanılan tüm altyapı dâhil olmak üzere {APP} platformunun tamamı.</li>
        <li><strong>&quot;Kullanıcı&quot; / &quot;Siz&quot;</strong> - hesap oluşturan ve Hizmet&apos;i kullanan her gerçek veya tüzel kişi.</li>
        <li><strong>&quot;Kurulum&quot; (Instance)</strong> - Hizmet üzerinden oluşturulan, kendi çalışma ortamı, veritabanı ve yapılandırmasına sahip bağımsız uygulama örneği.</li>
        <li><strong>&quot;Kullanıcı Verisi&quot;</strong> - sizin veya son kullanıcılarınızın bir Kurulum&apos;a girdiği tüm veriler (müşteri kayıtları, finansal veriler, iş bilgileri vb.).</li>
        <li><strong>&quot;Platform Verisi&quot;</strong> - hesap bilgileri, faturalandırma verileri, kullanım kayıtları ve yapılandırma meta verileri gibi Hizmet&apos;in kendisi tarafından yönetilen veriler.</li>
      </ul>

      <h2>3. Hizmet Tanımı</h2>
      <p>
        {APP}, iş uygulaması kurulumlarınızı hızlıca oluşturmanızı ve yönetmenizi sağlayan bir barındırma
        platformudur. Hizmet kapsamında sunulan başlıca özellikler:
      </p>
      <ul>
        <li>Otomatik kurulum oluşturma ve yaşam döngüsü yönetimi (başlatma, durdurma, yeniden başlatma, silme).</li>
        <li>Özel alan adı (domain) bağlama ve otomatik SSL/TLS sertifikası sağlama.</li>
        <li>Eklenti (addon) yükleme ve yönetimi.</li>
        <li>Veritabanı yedekleme ve geri yükleme.</li>
        <li>Kullanıcı ve yetki yönetimi (yönetici, standart kullanıcı).</li>
      </ul>
      <p>
        Hizmet, operatör tarafından yönetilen altyapı üzerinde çalışır. Her kurulum, izole edilmiş
        konteyner tabanlı bir ortamda ve kendine ait veritabanıyla çalıştırılır. Bu, dijital ve sürekli
        sunulan bir abonelik hizmetidir; fiziksel bir ürün teslimatı içermez. Ödemesi tamamlanan abonelik,
        sistem tarafından anında etkinleştirilir ve Kullanıcı Hizmet&apos;e derhâl erişebilir.
      </p>

      <h2>4. Üyelik ve Hesap</h2>
      <p>
        Hizmet&apos;i kullanabilmek için 18 yaşını doldurmuş olmanız (veya bulunduğunuz ülkede reşit sayılmanız)
        gerekir. Kayıt olurken kendinizi ve varsa temsil ettiğiniz kuruluşu bu Sözleşme ile bağlama yetkisine
        sahip olduğunuzu beyan etmiş sayılırsınız.
      </p>
      <p>
        Hesap bilgilerinizin (kullanıcı adı, parola) gizliliğinden yalnızca siz sorumlusunuz. Hesabınıza
        yetkisiz erişim fark ederseniz derhâl bizi bilgilendirmeyi kabul edersiniz. Hesabınızın yetkisiz
        kullanımından doğan zararlardan sorumlu değiliz.
      </p>

      <h2>5. Kabul Edilebilir Kullanım</h2>
      <p>Hizmet&apos;i kullanırken <strong>aşağıdakileri yapmamayı</strong> kabul edersiniz:</p>
      <ul>
        <li>Hizmet&apos;i hukuka aykırı herhangi bir amaçla veya yürürlükteki mevzuata aykırı biçimde kullanmak.</li>
        <li>Hizmet&apos;in herhangi bir bölümüne, diğer kullanıcıların hesaplarına veya altyapıya (konteynerler, veritabanları, sunucular) yetkisiz erişim sağlamaya çalışmak.</li>
        <li>Platforma zararlı kod, kötü amaçlı yazılım veya güvenlik açığı içeren eklentiler yüklemek.</li>
        <li>Aşırı istekle altyapıyı yormak dâhil olmak üzere Hizmet&apos;i kesintiye uğratmak veya bozmak (hizmet dışı bırakma / DoS davranışı).</li>
        <li>Hizmet üzerinden spam, kimlik avı (phishing) veya istenmeyen toplu iletişim göndermek.</li>
        <li>Platformun kaynak kodunu tersine mühendislikle çözmeye, kopyalamaya veya çıkarmaya çalışmak (yürürlükteki hukukun izin verdiği hâller hariç).</li>
        <li>Üçüncü kişilerin fikrî mülkiyet, gizlilik veya veri koruma haklarını ihlal eden veriler saklamak veya işlemek.</li>
        <li>Kullanım limitlerini, faturalandırma mekanizmalarını veya erişim kontrollerini aşmak.</li>
      </ul>
      <p>
        Bu koşulların ihlali, hesabınızın önceden bildirim yapılmaksızın askıya alınmasına veya kapatılmasına
        ve - hukuka aykırı kullanım hâllerinde - ücret iadesi yapılmamasına yol açabilir.
      </p>
      <p>
        <strong>Terör, terörün finansmanı, çocukların cinsel istismarı, dolandırıcılık, kara para aklama veya
        diğer ağır suçların işlenmesine yönelik kullanım tespit edildiğinde, ilgili hesap ve kurulumlar önceden
        bildirim yapılmaksızın derhâl (anında) sonlandırılır ve durum, yürürlükteki mevzuat uyarınca yetkili
        adli ve idari makamlara bildirilir.</strong> Bu hâllerde, yasal taleplere yanıt verebilmek amacıyla
        ilgili günlük (log) ve kayıtlar mevzuatın öngördüğü süre boyunca saklanabilir. Yetkili makamlara yapılan
        bu bildirim ve veri paylaşımı, 6698 sayılı KVKK&apos;nın açık rıza aranmayan hâllerine (kanunlarda açıkça
        öngörülme, veri sorumlusunun hukuki yükümlülüğü, bir hakkın tesisi/korunması ve meşru menfaat) dayanır
        ve bunun için ayrıca rızanız aranmaz.
      </p>

      <h2>6. Verileriniz ve Sorumluluğunuz</h2>
      <h3>6.1 Veri Sahipliği</h3>
      <p>
        <strong>Kurulumlarınızda saklanan tüm Kullanıcı Verisi üzerindeki mülkiyet size aittir.</strong> Verileriniz
        üzerinde herhangi bir mülkiyet iddiasında bulunmayız. Kurulum verilerinize yalnızca Hizmet&apos;i sunmak
        için gerekli olduğu ölçüde (örneğin yedekleme, kurulum işlemleri veya sizin talebinizle yapılan destek)
        erişiriz.
      </p>
      <h3>6.2 Verilere İlişkin Sorumluluğunuz</h3>
      <p>Aşağıdakilerden yalnızca siz sorumlusunuz:</p>
      <ul>
        <li>Tüm Kullanıcı Verisi&apos;nin hukuka uygunluğu, doğruluğu ve yerindeliği.</li>
        <li>Sakladığınız verilere uygulanan veri koruma mevzuatına (KVKK, GDPR ve sektörel düzenlemeler dâhil) uyum.</li>
        <li>Kurulumlarınız aracılığıyla işlediğiniz kişisel veriler için son kullanıcılarınızdan gerekli açık rızaların alınması.</li>
        <li>Kurulumlarınız içinde uygun veri işleme uygulamalarının hayata geçirilmesi.</li>
      </ul>
      <h3>6.3 Yedekleme</h3>
      <div className="legal-warning">
        ⚠️ <strong>Yedeklemelerle ilgili açık not:</strong> Yedeklemeler konusunda hiçbir şekilde garanti
        verilmemektedir. Yedeklerin alınabilmesi, eksiksizliği veya geri yüklenebilmesi taahhüt edilmez.
      </div>
      <p>
        Sağlayıcı, belirli planlar kapsamında iyi niyet çerçevesinde periyodik yedekleme yapabilir; ancak bu özellik
        bir garanti değil, ek bir kolaylık olarak sunulur ve <strong>yedeklerin eksiksizliği, güncelliği veya geri
        yüklenebilmesi taahhüt edilmez.</strong> Verilerin güncel bir kopyasını harici/bağımsız bir ortamda saklamak
        <strong>müşterinin sorumluluğundadır</strong>: panel üzerinden düzenli olarak <strong>manuel yedek almanız</strong>
        ve bu yedeklerin bir kopyasını ayrı bir ortamda tutmanız (&quot;yedeğin yedeği&quot; ilkesi) sizin
        yükümlülüğünüzdedir. Kurulum silme, altyapı arızası, yedekleme veya geri yükleme hatası ya da başka bir nedenle
        oluşabilecek veri kaybına ilişkin sorumluluğumuz, <strong>kast ve ağır ihmal hâlleri saklı kalmak kaydıyla</strong>,
        aşağıdaki 10. maddede belirtilen sınırlarla bağlıdır. <strong>%100 yedek garantisi yalnızca ayrı ve özel bir
        yazılı anlaşma ile sağlanabilir.</strong>
      </p>
      <h3>6.4 Muhasebe ve Finansal Verilerin Doğruluğu</h3>
      <p>
        {APP} yalnızca barındırma altyapısını ve araçlarını sağlar. Kurulumlarınızda tutulan muhasebe, finansal,
        vergisel veya diğer iş verilerinin doğruluğu, eksiksizliği, hesaplamaların isabetliliği veya mevzuata
        uygunluğu konusunda <strong>herhangi bir garanti vermez ve kast ile ağır ihmal hâlleri saklı kalmak kaydıyla
        sorumluluk kabul etmeyiz.</strong> Bu veriler ile bunlara dayanan raporların, beyanların ve kararların
        doğruluğundan yalnızca siz sorumlusunuz; gerekli kontrolleri yapmak ve yeminli mali müşavir/muhasebeci desteği
        almak sizin yükümlülüğünüzdedir.
      </p>
      <h3>6.5 Kurulum Yapılandırması</h3>
      <p>
        Eklenti seçimi, özel alan adı kurulumu (DNS ayarlarının doğruluğu dâhil), uygulama içindeki kullanıcı
        erişim kontrolleri ve veritabanı yönetimi dâhil kurulumlarınızın yapılandırmasından siz sorumlusunuz.
        Biz platformu ve araçları sağlarız; <strong>yapılandırmanızın doğruluğu ve güvenliği sizin
        sorumluluğunuzdadır.</strong>
      </p>

      <h2>7. Hizmet Sürekliliği ve Bakım</h2>
      <h3>7.1 Azami Çaba İlkesi</h3>
      <p>
        Hizmet&apos;i yüksek erişilebilirlikte tutmaya çalışırız; ancak ayrı bir yazılı sözleşmede açıkça
        belirtilmedikçe <strong>belirli bir çalışma süresi (uptime) yüzdesi veya hizmet seviyesi anlaşması (SLA)
        garanti etmeyiz.</strong> Hizmet &quot;azami çaba&quot; esasıyla sunulur.
      </p>
      <h3>7.2 Planlı ve Plansız Bakım</h3>
      <p>
        Hizmet&apos;i geçici olarak kesintiye uğratabilecek planlı bakımlar yapabiliriz ve mümkün olduğunda önceden
        bilgilendirmeye çalışırız. Hizmet&apos;in güvenliğini, bütünlüğünü veya erişilebilirliğini korumak için gerekli
        olan acil bakım ve düzeltmeler önceden bildirim yapılmaksızın gerçekleştirilebilir.
      </p>
      <h3>7.3 Kesintiye İlişkin Sorumluluk</h3>
      <p>
        Yürürlükteki hukukun izin verdiği azami ölçüde, altyapı arızaları, yazılım hataları, bakım, mücbir
        sebepler, üçüncü taraf hizmet kesintileri (DNS, sertifika sağlayıcıları, ödeme kuruluşları vb.) veya
        sizin yapılandırma hatalarınızdan kaynaklanan kesinti ve erişilemezliklerden doğan zararlardan sorumlu
        tutulamayız.
      </p>

      <h2>8. Ücretlendirme, Abonelik ve Ödeme</h2>
      <p>
        Hizmet&apos;in belirli özellikleri ücretli aboneliğe tabidir. Ücretli bir plana abone olarak, fiyatlandırma
        sayfasında belirtilen ücretleri ödemeyi kabul edersiniz. Aksi belirtilmedikçe tüm ücretlere ilgili
        vergiler dâhil değildir.
      </p>
      <p>
        <strong>Ödemeler, lisanslı bir ödeme kuruluşu aracılığıyla güvenli biçimde işlenir.</strong>
        Kart bilgileriniz ödeme kuruluşunun güvenli sanal POS/ödeme sayfasında işlenir; kredi kartı numaranızın
        tamamı sunucularımızda saklanmaz. Biz yalnızca faturalandırma tanımlayıcılarını, plan bilgilerini ve işlem
        geçmişini tutarız. Ödeme işlemlerinde ilgili ödeme kuruluşunun kullanım ve gizlilik koşulları da geçerlidir.
      </p>
      <p>
        Abonelikler, yenileme tarihinden önce iptal edilmedikçe her fatura döneminin (aylık veya yıllık) sonunda
        otomatik olarak yenilenir. Yenilenen dönem için ödeme yönteminizden tahsilat yapılmasına (ödeme kuruluşu
        aracılığıyla) onay vermiş olursunuz.
      </p>

      <h2>9. İptal ve İade Koşulları</h2>
      <p>
        Aboneliğinizi dilediğiniz zaman hesap panelinden iptal edebilirsiniz. İptal, bir sonraki yenileme
        döneminde geçerli olur; iptal ettiğinizde mevcut fatura döneminin sonuna kadar ücretli özelliklere
        erişiminiz devam eder.
      </p>
      <p>
        {APP}, dijital ve anında sunulan sürekli bir hizmet olduğundan, kullanılan dönem için ödenen abonelik
        ücretleri kural olarak <strong>iade edilmez.</strong> Bununla birlikte, tamamen kullanılmamış bir fatura
        dönemi için yapılan bir hatalı/mükerrer tahsilat söz konusuysa veya bize atfedilebilen sürekli bir hizmet
        aksaklığı yaşandıysa, talebinizi değerlendirir ve uygun gördüğümüz hâllerde orantılı iade veya kredi
        sağlayabiliriz. İade talepleri, aşağıda belirtilen iletişim adresinden bize ulaştırılabilir; onaylanan
        iadeler, ödemenin yapıldığı karta/ödeme yöntemine ödeme kuruluşu üzerinden ve yasal süreler içinde yapılır.
      </p>
      <p>
        Tüketici mevzuatı kapsamındaki kullanıcılar için ilgili cayma ve iade hakları saklıdır. Anında ifa
        edilen dijital hizmetlerde, hizmetin ifasına başlanmasıyla birlikte cayma hakkının sona erebileceğini
        hatırlatırız.
      </p>

      <h2>10. Sorumluluğun Sınırlandırılması</h2>
      <p>Yürürlükteki hukukun izin verdiği azami ölçüde:</p>
      <ul>
        <li><strong>Dolaylı zararlar:</strong> Hiçbir hâlde; kâr, gelir, veri, iş fırsatı veya itibar kaybı dâhil olmak üzere Hizmet&apos;in kullanımından kaynaklanan dolaylı, arızi, özel veya cezai zararlardan sorumlu değiliz.</li>
        <li><strong>Toplam üst sınır:</strong> Bu Sözleşme ve Hizmet&apos;e ilişkin toplam sorumluluğumuz, talebe yol açan olaydan önceki son iki (2) ay içinde bize ödediğiniz hizmet bedelini aşamaz.</li>
        <li><strong>Kullanıcı Verisi:</strong> Ağır kusur veya kasıt hâlleri dışında, kurulumlarınızdaki Kullanıcı Verisi&apos;nin kaybı, bozulması veya yetkisiz erişiminden sorumlu değiliz.</li>
        <li><strong>Hatalı yapılandırma:</strong> Yanlış DNS ayarları, uyumsuz eklentiler, kaynak tüketimi veya hatalı erişim kontrolleri gibi yapılandırma tercihlerinizden doğan sorunlardan sorumlu değiliz.</li>
      </ul>
      <p>
        <strong>Kast ve ağır ihmal saklıdır.</strong> Bu maddedeki sorumsuzluk ve sınırlandırma kayıtları; kastımızdan
        veya ağır ihmalimizden doğan zararlar ile emredici hukuk kuralları gereği bertaraf edilemeyecek sorumluluk
        hâlleri (Türk Borçlar Kanunu m.115 dâhil) bakımından uygulanmaz. Tüketici sıfatını haiz kullanıcıların
        tüketici mevzuatından doğan hakları saklıdır.
      </p>

      <h2>11. Tazminat</h2>
      <p>
        Hizmet&apos;i kullanımınız, bu Sözleşme&apos;yi veya yürürlükteki mevzuatı ya da üçüncü kişi haklarını ihlaliniz
        veya kurulumlarınızda işlediğiniz verilerle ilgili olarak {APP}&apos;e yöneltilebilecek her türlü talep, zarar
        ve masraftan (makul avukatlık ücretleri dâhil) {APP}&apos;i beri kılmayı ve zararını tazmin etmeyi kabul
        edersiniz.
      </p>

      <h2>12. Garanti Reddi</h2>
      <p>
        <strong>Hizmet &quot;OLDUĞU GİBİ&quot; ve &quot;MEVCUT HÂLİYLE&quot; sunulur; açık, zımni veya kanuni hiçbir garanti
        verilmez.</strong> Ticari elverişlilik, belirli bir amaca uygunluk ve ihlal etmeme dâhil olmak üzere tüm
        zımni garantileri açıkça reddederiz. Hizmet&apos;in kesintisiz, hatasız veya tümüyle güvenli olacağını taahhüt
        etmeyiz. Hizmet&apos;i kendi riskinizle kullandığınızı kabul edersiniz.
      </p>

      <h2>13. Fikrî Mülkiyet</h2>
      <p>
        Kod, tasarım, dokümantasyon ve marka dâhil olmak üzere Hizmet&apos;in fikrî mülkiyeti {APP}&apos;e (veya
        lisans verenlerine) aittir. Bu Sözleşme, markalarımızı, logolarımızı veya kurumsal kimliğimizi önceden
        yazılı izin olmaksızın kullanma hakkı vermez.
      </p>
      <p>
        Hizmet, açık kaynaklı yazılım uygulamalarını barındırır. &quot;Odoo&quot; dâhil tüm markalar ilgili sahiplerine
        aittir. {APP}; Odoo S.A. veya başka bir yazılım sağlayıcısıyla bağlantılı, onlar tarafından desteklenen
        veya onaylanan bir kuruluş değildir. Hizmet içindeki açık kaynaklı yazılımların kullanımı, ilgili açık
        kaynak lisanslarına (örneğin Odoo Community Edition için LGPL) tabidir.
      </p>

      <h2>14. Sözleşmenin Feshi</h2>
      <h3>14.1 Sizin Tarafınızdan</h3>
      <p>
        Kurulumlarınızı silerek ve hesabınızın kapatılmasını talep ederek Sözleşme&apos;yi dilediğiniz zaman
        feshedebilirsiniz. Fesih hâlinde tüm kurulumlarınız kalıcı olarak silinir ve ilgili veriler Gizlilik
        Politikası&apos;na uygun şekilde imha edilir.
      </p>
      <h3>14.2 Bizim Tarafımızdan</h3>
      <p>Aşağıdaki hâllerde hesabınızı önceden bildirim yapmaksızın askıya alabilir veya kapatabiliriz:</p>
      <ul>
        <li>Bu Sözleşme&apos;yi ihlal etmeniz.</li>
        <li>Hizmet&apos;i kullanımınızın platform veya diğer kullanıcılar için güvenlik riski oluşturması.</li>
        <li>Kanunen zorunlu olması.</li>
        <li>Hizmet&apos;i durdurmamız (makul bir bildirimle).</li>
      </ul>

      <h2>15. Uyuşmazlıkların Çözümü ve Geçerli Hukuk</h2>
      <p>
        Bu Sözleşme, Türkiye Cumhuriyeti kanunlarına tabidir. Taraflar, herhangi bir uyuşmazlığı öncelikle
        iyi niyetle ve dostane biçimde çözmeye çalışır. Uzlaşma sağlanamazsa, yetkili Türkiye mahkemeleri ve
        icra daireleri yetkilidir. Tüketici sıfatını haiz kullanıcılar için ilgili Tüketici Hakem Heyetleri ve
        Tüketici Mahkemeleri&apos;nin yetkisi saklıdır.
      </p>

      <h2>16. Mücbir Sebep</h2>
      <p>
        Doğal afet, salgın, savaş, terör, ayaklanma, kamu otoritesi kararları, elektrik veya internet kesintileri,
        siber saldırılar ya da üçüncü taraf hizmet sağlayıcılarının arızaları gibi makul kontrolümüz dışındaki
        nedenlerle yükümlülüklerimizi yerine getirememekten sorumlu değiliz.
      </p>

      <h2>17. Değişiklikler</h2>
      <p>
        Bu Sözleşme&apos;yi zaman zaman güncelleyebiliriz. Esaslı değişikliklerde bu sayfadaki &quot;Son güncelleme&quot;
        tarihini değiştirir ve kayıtlı kullanıcıları bilgilendiririz. Değişikliklerin yürürlüğe girmesinden sonra
        Hizmet&apos;i kullanmaya devam etmeniz, güncellenen koşulları kabul ettiğiniz anlamına gelir.
      </p>

      <h2>18. Muhtelif Hükümler</h2>
      <ul>
        <li><strong>Bütünlük:</strong> Bu Sözleşme, Gizlilik Politikası ile birlikte, Hizmet&apos;e ilişkin taraflar arasındaki bütünü oluşturur.</li>
        <li><strong>Bölünebilirlik:</strong> Herhangi bir hükmün geçersiz sayılması, diğer hükümlerin geçerliliğini etkilemez.</li>
        <li><strong>Feragatten kaçınma:</strong> Bir hakkımızı kullanmamamız, o haktan feragat ettiğimiz anlamına gelmez.</li>
        <li><strong>Devir:</strong> Önceden yazılı iznimiz olmadan bu Sözleşme&apos;deki hak ve yükümlülüklerinizi devredemezsiniz.</li>
      </ul>

      <h2>19. İletişim</h2>
      <p>Bu Sözleşme hakkında sorularınız için bize ulaşabilirsiniz:</p>
      <ul>
        <li><strong>E-posta:</strong> hukuk@provisyer.com</li>
        <li><strong>Konu:</strong> &quot;Hizmet Şartları&quot;</li>
      </ul>
    </LegalShell>
  )
}

/* ------------------------------------------------------------------ */
/* ENGLISH                                                             */
/* ------------------------------------------------------------------ */
function TermsEN() {
  return (
    <LegalShell lang="en" page="terms" title="Terms of Service" updated="Last updated: July 24, 2026">
      <p>
        These Terms of Service (&quot;Terms&quot;) govern your use of the {APP} platform (the &quot;Service&quot;),
        a hosting service that provides businesses with cloud-hosted business applications (Odoo-based ERP
        instances and related infrastructure). {APP} is an independent hosting service and is not affiliated
        with, endorsed by, or sponsored by Odoo S.A. or any software vendor. By creating an account or using
        the Service, you agree to be bound by these Terms. If you do not agree, do not use the Service.
      </p>

      <h2>1. Parties and Scope</h2>
      <p>
        These Terms form an electronic agreement between the platform operator ({APP}, &quot;we&quot;) and the
        individual or entity that registers for the Service (&quot;User&quot;, &quot;you&quot;). They remain in
        effect for as long as you use the Service.
      </p>

      <h2>2. Definitions</h2>
      <ul>
        <li><strong>&quot;Service&quot;</strong> means the {APP} platform, including the web application, API, and all infrastructure used to provision, manage, and host instances.</li>
        <li><strong>&quot;User&quot; / &quot;You&quot;</strong> means any individual or entity that creates an account and uses the Service.</li>
        <li><strong>&quot;Instance&quot;</strong> means an individual application deployment created through the Service, including its runtime, database, and configuration.</li>
        <li><strong>&quot;User Data&quot;</strong> means all data you or your end-users enter into an Instance, including customer records, financial data, and business information.</li>
        <li><strong>&quot;Platform Data&quot;</strong> means account information, billing data, usage logs, and configuration metadata managed by the Service itself.</li>
      </ul>

      <h2>3. Service Description</h2>
      <p>{APP} is a hosting platform that lets you quickly provision and manage business application instances. The Service includes:</p>
      <ul>
        <li>Automated instance creation and lifecycle management (start, stop, restart, delete).</li>
        <li>Custom domain configuration with automatic SSL/TLS certificate provisioning.</li>
        <li>Addon upload and management.</li>
        <li>Database backup and restore.</li>
        <li>User and role management (admin, standard user).</li>
      </ul>
      <p>
        The Service runs on operator-managed infrastructure. Each instance runs in an isolated container-based
        environment with its own dedicated database. This is a digital, continuously delivered subscription
        service and involves no physical product delivery. Once a subscription payment is completed, access is
        activated immediately and automatically.
      </p>

      <h2>4. Eligibility and Account</h2>
      <p>
        You must be at least 18 years old (or of legal majority in your jurisdiction) to use the Service. By
        registering, you represent that you have authority to bind yourself and, if applicable, your organization
        to these Terms.
      </p>
      <p>
        You are responsible for keeping your credentials confidential and agree to notify us immediately of any
        unauthorized access. We are not liable for any loss arising from unauthorized use of your account.
      </p>

      <h2>5. Acceptable Use</h2>
      <p>You agree <strong>not</strong> to:</p>
      <ul>
        <li>Use the Service for any unlawful purpose or in violation of applicable law.</li>
        <li>Attempt to gain unauthorized access to any part of the Service, other users&apos; accounts, or the underlying infrastructure.</li>
        <li>Upload malicious code, malware, or harmful addons.</li>
        <li>Interfere with or disrupt the Service, including overwhelming infrastructure (denial-of-service behavior).</li>
        <li>Use the Service to send spam, phishing, or other unsolicited communications.</li>
        <li>Reverse engineer, decompile, or extract the platform&apos;s source code (except where permitted by law).</li>
        <li>Store or process data that violates third-party rights, including intellectual property, privacy, or data protection laws.</li>
        <li>Circumvent usage limits, billing mechanisms, or access controls.</li>
      </ul>
      <p>Violation may result in immediate suspension or termination without prior notice or refund.</p>
      <p>
        <strong>Where use of the Service for terrorism, financing of terrorism, child sexual abuse, fraud, money
        laundering, or other serious crimes is detected, the relevant account and instances are terminated
        immediately without prior notice, and the matter is reported to the competent judicial and administrative
        authorities in accordance with applicable law.</strong> In such cases, relevant logs and records may be
        retained for the period required by law in order to respond to lawful requests. Such reporting and data
        sharing with authorities rely on the grounds under KVKK No. 6698 for which explicit consent is not
        required (express provision in law, the controller&apos;s legal obligation, establishment/protection of a
        right, and legitimate interest), and no separate consent is required for it.
      </p>

      <h2>6. Your Data and Responsibility</h2>
      <h3>6.1 Data Ownership</h3>
      <p>
        <strong>You retain full ownership of all User Data stored in your Instances.</strong> We claim no ownership
        over your data and access it only as necessary to provide the Service (e.g., backups, provisioning,
        support at your request).
      </p>
      <h3>6.2 Your Responsibility for Data</h3>
      <p>You are solely responsible for:</p>
      <ul>
        <li>The legality, accuracy, and appropriateness of all User Data.</li>
        <li>Compliance with data-protection laws applicable to the data you store (including KVKK, GDPR, and sector-specific rules).</li>
        <li>Obtaining necessary consents from your end-users for personal data processed through your Instances.</li>
        <li>Implementing appropriate data-handling practices within your Instances.</li>
      </ul>
      <h3>6.3 Backups</h3>
      <div className="legal-warning">
        ⚠️ <strong>Important note on backups:</strong> Backups are not guaranteed in any way. We make no guarantee
        as to their availability, completeness, or restorability.
      </div>
      <p>
        We may perform periodic backups in good faith on certain plans; however, this is offered as a convenience,
        not a guarantee, and <strong>we do not warrant the completeness, currency, or restorability of any backup.</strong>
        Keeping a current copy of your data in an external/independent location is <strong>your responsibility</strong>:
        taking regular <strong>manual backups from the panel</strong> and keeping an independent copy of them (the
        &quot;backup-of-backup&quot; principle) is your obligation. Our liability for any data loss resulting from
        instance deletion, infrastructure failure, backup or restore errors, or any other cause is subject to the
        limits in Section 10, <strong>save for cases of our intent or gross negligence.</strong> <strong>A 100% backup
        guarantee is available only under a separate written agreement.</strong>
      </p>
      <h3>6.4 Accuracy of Accounting and Financial Data</h3>
      <p>
        {APP} provides the hosting infrastructure and tools only. We give <strong>no warranty</strong> as to, and -
        save for cases of intent or gross negligence - <strong>accept no responsibility</strong> for, the accuracy,
        completeness, correctness of calculations, or legal/tax compliance of any accounting, financial, tax, or other
        business data kept in your instances. You are solely responsible for the accuracy of such data and of any
        reports, filings, or decisions based on it, including performing the necessary checks and obtaining
        professional accounting/advisory support.
      </p>
      <h3>6.5 Instance Configuration</h3>
      <p>
        You are responsible for the configuration of your instances, including addon selection, custom domain
        setup (including correct DNS), in-app access controls, and database management. We provide the platform
        and tools; <strong>the correctness and security of your configuration is your responsibility.</strong>
      </p>

      <h2>7. Service Availability and Maintenance</h2>
      <h3>7.1 Best-Effort Availability</h3>
      <p>
        We strive for high availability but <strong>do not guarantee any specific uptime percentage or SLA unless
        stated in a separate written agreement.</strong> The Service is provided on a best-effort basis.
      </p>
      <h3>7.2 Scheduled and Unscheduled Maintenance</h3>
      <p>
        We may perform scheduled maintenance that temporarily interrupts the Service and will make reasonable
        efforts to notify you in advance. Emergency maintenance may occur without prior notice when necessary to
        protect the Service.
      </p>
      <h3>7.3 No Liability for Downtime</h3>
      <p>
        To the maximum extent permitted by law, we are not liable for damages arising from downtime or
        unavailability caused by infrastructure failures, software bugs, maintenance, force majeure, third-party
        outages (DNS, certificate authorities, payment processors), or your own configuration errors.
      </p>

      <h2>8. Billing, Subscription, and Payment</h2>
      <p>
        Certain features require a paid subscription. By subscribing, you agree to pay the fees shown on the
        pricing page. Unless stated otherwise, all fees are exclusive of applicable taxes.
      </p>
      <p>
        <strong>Payments are processed securely through a licensed payment institution.</strong>
        Your card details are handled on the payment institution&apos;s secure payment page; we do not store full card
        numbers on our servers. We retain only billing identifiers, plan details, and transaction history. The
        payment institution&apos;s own terms and privacy policy also apply to payment transactions.
      </p>
      <p>
        Subscriptions renew automatically at the end of each billing cycle (monthly or annually) unless cancelled
        beforehand. You authorize us, via our payment processor, to charge your payment method on a recurring
        basis.
      </p>

      <h2>9. Cancellation and Refunds</h2>
      <p>
        You may cancel your subscription at any time from your account dashboard. Cancellation takes effect at the
        next renewal; you retain access to paid features until the end of the current billing period.
      </p>
      <p>
        Because {APP} is a digital, immediately delivered, continuous service, subscription fees for a used period
        are generally <strong>non-refundable.</strong> However, in the case of a duplicate/erroneous charge for a
        wholly unused billing period, or a sustained service failure attributable to us, we will review your
        request and may, at our discretion, provide a prorated refund or credit. Approved refunds are returned to
        the original payment method via the payment institution within the statutory time frame. Statutory withdrawal and refund
        rights for consumer users are reserved; note that the right of withdrawal may lapse once performance of an
        immediately delivered digital service has begun.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law:</p>
      <ul>
        <li><strong>No consequential damages:</strong> we are not liable for any indirect, incidental, special, or punitive damages, including loss of profits, revenue, data, business opportunities, or goodwill.</li>
        <li><strong>Aggregate cap:</strong> our total liability shall not exceed the fees you paid us in the two (2) months preceding the event giving rise to the claim.</li>
        <li><strong>User Data:</strong> except in cases of gross negligence or willful misconduct, we are not liable for loss, corruption, or unauthorized access to User Data in your Instances.</li>
        <li><strong>Misconfiguration:</strong> we are not liable for issues arising from your configuration choices, including incorrect DNS, incompatible addons, or resource exhaustion.</li>
      </ul>
      <p>
        <strong>Intent and gross negligence reserved.</strong> The exclusions and limitations in this Section do not
        apply to damages arising from our intent or gross negligence, or to any liability that cannot be excluded
        under mandatory law (including Article 115 of the Turkish Code of Obligations). The statutory rights of users
        who qualify as consumers are reserved.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless {APP} from any claims, damages, and costs (including reasonable
        legal fees) arising from your use of the Service, your breach of these Terms or applicable law or
        third-party rights, or data you process in your Instances.
      </p>

      <h2>12. Disclaimer of Warranties</h2>
      <p>
        <strong>The Service is provided &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; without warranties of any
        kind,</strong> whether express, implied, or statutory. We disclaim all implied warranties, including
        merchantability, fitness for a particular purpose, and non-infringement. You use the Service at your own
        risk.
      </p>

      <h2>13. Intellectual Property</h2>
      <p>
        The Service, including its code, design, documentation, and trademarks, is the intellectual property of
        {' '}{APP} (or its licensors). These Terms grant you no right to use our trademarks, logos, or branding
        without prior written consent.
      </p>
      <p>
        The Service hosts open-source software applications. All trademarks, including &quot;Odoo&quot;, belong to
        their respective owners. {APP} is not affiliated with, endorsed by, or sponsored by Odoo S.A. or any other
        vendor. Use of open-source software within the Service is subject to the applicable licenses (e.g., LGPL
        for Odoo Community Edition).
      </p>

      <h2>14. Termination</h2>
      <h3>14.1 By You</h3>
      <p>
        You may terminate at any time by deleting your instances and requesting account deletion. Upon
        termination, all instances are permanently destroyed and associated data is deleted in accordance with our
        Privacy Policy.
      </p>
      <h3>14.2 By Us</h3>
      <p>We may suspend or terminate your account without prior notice if:</p>
      <ul>
        <li>You breach these Terms.</li>
        <li>Your use poses a security risk to the platform or other users.</li>
        <li>We are required to do so by law.</li>
        <li>We discontinue the Service (with reasonable notice).</li>
      </ul>

      <h2>15. Governing Law and Disputes</h2>
      <p>
        These Terms are governed by the laws of the Republic of Türkiye. The parties will first attempt to resolve
        any dispute amicably and in good faith. Failing that, the competent courts and execution offices of
        Türkiye have jurisdiction. For consumer users, the jurisdiction of the relevant Consumer Arbitration
        Committees and Consumer Courts is reserved.
      </p>

      <h2>16. Force Majeure</h2>
      <p>
        We are not liable for any failure or delay caused by events beyond our reasonable control, including
        natural disasters, epidemics, war, terrorism, government actions, power or internet outages, cyberattacks,
        or third-party service failures.
      </p>

      <h2>17. Modifications</h2>
      <p>
        We may update these Terms from time to time. For material changes, we will update the &quot;Last updated&quot;
        date and notify registered users. Your continued use after the effective date constitutes acceptance.
      </p>

      <h2>18. Miscellaneous</h2>
      <ul>
        <li><strong>Entire agreement:</strong> these Terms, together with the Privacy Policy, constitute the entire agreement regarding the Service.</li>
        <li><strong>Severability:</strong> if any provision is unenforceable, the remaining provisions remain in effect.</li>
        <li><strong>Waiver:</strong> our failure to enforce a right is not a waiver of it.</li>
        <li><strong>Assignment:</strong> you may not assign your rights without our prior written consent.</li>
      </ul>

      <h2>19. Contact</h2>
      <p>If you have questions about these Terms, contact us at:</p>
      <ul>
        <li><strong>Email:</strong> hukuk@provisyer.com</li>
        <li><strong>Subject:</strong> &quot;Terms Inquiry&quot;</li>
      </ul>
    </LegalShell>
  )
}
